import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=135d3aa0&scoped=true"
import script from "./SButton.vue?vue&type=script&lang=js"
export * from "./SButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d3aa0",
  null
  
)

export default component.exports